export default __webpack_public_path__ + "static/media/ic_block.e32af8b1.svg";